/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CredentialType } from './CredentialType';
import {
    CredentialTypeFromJSON,
    CredentialTypeFromJSONTyped,
    CredentialTypeToJSON,
} from './CredentialType';
import type { ExportedTOTPCredentialParams } from './ExportedTOTPCredentialParams';
import {
    ExportedTOTPCredentialParamsFromJSON,
    ExportedTOTPCredentialParamsFromJSONTyped,
    ExportedTOTPCredentialParamsToJSON,
} from './ExportedTOTPCredentialParams';

/**
 * 
 * @export
 * @interface ExportedTOTPCredential
 */
export interface ExportedTOTPCredential {
    /**
     * The ID of the credential
     * @type {string}
     * @memberof ExportedTOTPCredential
     */
    id: string;
    /**
     * The time when the credential was last used to authenticate successfully
     * @type {Date}
     * @memberof ExportedTOTPCredential
     */
    last_used?: Date;
    /**
     * 
     * @type {CredentialType}
     * @memberof ExportedTOTPCredential
     */
    type: CredentialType;
    /**
     * 
     * @type {ExportedTOTPCredentialParams}
     * @memberof ExportedTOTPCredential
     */
    params: ExportedTOTPCredentialParams;
    /**
     * 
     * @type {string}
     * @memberof ExportedTOTPCredential
     */
    label?: string;
}

/**
 * Check if a given object implements the ExportedTOTPCredential interface.
 */
export function instanceOfExportedTOTPCredential(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "params" in value;

    return isInstance;
}

export function ExportedTOTPCredentialFromJSON(json: any): ExportedTOTPCredential {
    return ExportedTOTPCredentialFromJSONTyped(json, false);
}

export function ExportedTOTPCredentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportedTOTPCredential {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'last_used': !exists(json, 'last_used') ? undefined : (new Date(json['last_used'])),
        'type': CredentialTypeFromJSON(json['type']),
        'params': ExportedTOTPCredentialParamsFromJSON(json['params']),
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function ExportedTOTPCredentialToJSON(value?: ExportedTOTPCredential | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'last_used': value.last_used === undefined ? undefined : (value.last_used.toISOString()),
        'type': CredentialTypeToJSON(value.type),
        'params': ExportedTOTPCredentialParamsToJSON(value.params),
        'label': value.label,
    };
}

